const formatPrice = price => {
    let dollarUSLocale = Intl.NumberFormat("en-US")
    return price ? dollarUSLocale.format((+price).toFixed(2)) : 0
}

export default formatPrice
